import { render, staticRenderFns } from "./TransferenciaCreate.vue?vue&type=template&id=b30c74e2&scoped=true&"
import script from "./TransferenciaCreate.vue?vue&type=script&lang=js&"
export * from "./TransferenciaCreate.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciaCreate.vue?vue&type=style&index=0&id=b30c74e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30c74e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VLayout,
  VSelect,
  VTextField,
})
